import { useMemo } from 'react';
import { numberWithComma } from 'src/utils/Utils';
import { beNumber, numberLength12 } from 'src/utils/CustomValidators';

export const formatInt = value => {
  if (value === null || value === undefined) return '—';
  const num = Number(value);
  if (Number.isNaN(num)) return '—';
  if (num === 0) return '0';
  return numberWithComma(Math.round(num));
};

export const parseValue = value => {
  if (value === null || value === undefined || value === '') return 0;
  const num = Number(value);
  return Number.isNaN(num) ? 0 : Math.round(num);
};

export const isValidNumericInput = value => {
  if (!value) return true;
  if (beNumber(value)) return false;
  if (numberLength12(value)) return false;
  return true;
};

export const useMainDeclarationCalculation = (draft, isEditing) =>
  useMemo(
    () => {
      if (!isEditing || !draft) return {};

      const ct19 = parseValue(draft.ct19ResidentWithTax);
      const ct20 = parseValue(draft.ct20NonResidentWithTax);
      const ct22 = parseValue(draft.ct22ResidentTaxableIncome);
      const ct23 = parseValue(draft.ct23NonResidentTaxableIncome);
      const ct24 = parseValue(draft.ct24InsurancePremium);
      const ct27 = parseValue(draft.ct27ResidentTaxableSubjectToWithholding);
      const ct28 = parseValue(draft.ct28NonResidentTaxableSubjectToWithholding);
      const ct30 = parseValue(draft.ct30ResidentTax);
      const ct31 = parseValue(draft.ct31NonResidentTax);

      return {
        ct18TotalWithTax: ct19 + ct20,
        ct21TotalTaxableIncome: ct22 + ct23,
        ct26TotalTaxableSubjectToWithholding: ct27 + ct28,
        ct29TotalTaxWithheld: ct30 + ct31,
        ct32InsuranceTax: Math.round(ct24 * 0.1)
      };
    },
    [isEditing, draft]
  );

export const useTaxAllocationTotals = visibleAllocations =>
  useMemo(
    () =>
      visibleAllocations.reduce(
        (acc, alloc) => ({
          ct10: acc.ct10 + parseValue(alloc.ct10TaxableIncome),
          ct11: acc.ct11 + parseValue(alloc.ct11TaxableIncomeSubjectToWh),
          ct12: acc.ct12 + parseValue(alloc.ct12EmployeeCount),
          ct13: acc.ct13 + parseValue(alloc.ct13EmployeesWithTax),
          ct14: acc.ct14 + parseValue(alloc.ct14TaxWithheld)
        }),
        { ct10: 0, ct11: 0, ct12: 0, ct13: 0, ct14: 0 }
      ),
    [visibleAllocations]
  );
